import { useState } from 'react';
import { StrategicAllyFilters } from './filters';
import { StrategicAllyList } from './list';
import { LayoutModule } from '../../../layout/modules';
import { StrategicAllyFilter } from '../../../../shared/types/modules/strategicAlly';
import { StrategicAllyProps } from './props';

export const StrategicAlly = ({
    showTitle,
    onClickRow,
}: StrategicAllyProps) => {
    const [filters, setFilters] = useState<StrategicAllyFilter>();

    return (
        <LayoutModule
            title="Búsqueda de aliados estratégicos"
            showTitle={showTitle}
        >
            <StrategicAllyFilters onFilter={(filters) => setFilters(filters)} />
            <StrategicAllyList filters={filters} onClickRow={onClickRow} />
        </LayoutModule>
    );
};
